// third-party
import { FormattedMessage } from "react-intl";

import {
  LocusCMSMessagesIcon,
  LocusFileUploadIcon,
  LocusDeviceConfigurationIcon,
} from "assets/icons/LocusIcons.js";
import { LOCUS_TOOLS_USER } from "../utils/constants/user";

// ==============================|| APPLICATION MENU ITEMS ||============================== //
/** @type {LocusMenuGroup} */
const tools = {
  id: "tools",
  title: <FormattedMessage id="tools" />,
  type: "group",
  view: ["site"],
  children: [
    {
      id: "device-configuration",
      title: <FormattedMessage id="ipad-access" />,
      type: "item",
      icon: LocusDeviceConfigurationIcon,
      url: "tools/device-configuration?site=:siteId",
      breadcrumbs: true,
      view: ["site"],
      allowedGroups: [LOCUS_TOOLS_USER],
    },
    {
      id: "site-file-upload",
      title: <FormattedMessage id="site-file-upload" />,
      type: "item",
      icon: LocusFileUploadIcon,
      url: "tools/site-file-upload?site=:siteId",
      breadcrumbs: true,
      view: ["site"],
      allowedGroups: [LOCUS_TOOLS_USER],
    },
    {
      id: "integration-monitoring",
      title: <FormattedMessage id="integration-monitoring" />,
      type: "item",
      icon: LocusCMSMessagesIcon,
      url: "tools/integration-monitoring?site=:siteId",
      breadcrumbs: true,
      view: ["site"],
      allowedGroups: [LOCUS_TOOLS_USER],
    },
  ],
};

export default tools;
